export const GET_AUTHENTICATED = 'GET_AUTHENTICATED';

export const SET_APIKEY = 'SET_APIKEY';
export const GET_APIKEY = 'GET_APIKEY';
export const REMOVE_APIKEY = 'REMOVE_APIKEY';

export const SET_TOKEN = 'SET_TOKEN';
export const GET_TOKEN = 'GET_TOKEN';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';

export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
export const GET_REFRESH_TOKEN = 'GET_REFRESH_TOKEN';
export const REMOVE_REFRESH_TOKEN = 'REMOVE_REFRESH_TOKEN';
